/* eslint-disable max-len */
import demoAgeIcon from './images/insight360/demo-age-icon.png';
import demoOccupationIcon from './images/insight360/demo-occupation-icon.png';
import demoChildrenIcon from './images/insight360/demo-children-icon.png';
import demoEducationIcon from './images/insight360/demo-education-icon.png';
import demoEmploymentIcon from './images/insight360/demo-employment-icon.png';
import demoEthnicityIcon from './images/insight360/demo-ethnicity-icon.png';
import demoGenderIcon from './images/insight360/demo-gender-icon.png';
import demoIncomeIcon from './images/insight360/demo-income-icon.png';
import demoMaritalStatusIcon from './images/insight360/demo-marital-status-icon.png';
import demoPoliticalIcon from './images/insight360/demo-political-icon.png';
import demoRaceIcon from './images/insight360/demo-race-icon.png';
import demoRegionIcon from './images/insight360/demo-region-icon.png';
import demoResidenceIcon from './images/insight360/demo-residence-icon.png';
import apparelIcon from './images/insight360/360-apparel-icon.png';
import autoIcon from './images/insight360/360-auto-icon.png';
import cellphonesIcon from './images/insight360/360-cellphones-icon.png';
import consumerPrivacyIcon from './images/insight360/360-consumer-privacy-icon.png';
import dietHealthIcon from './images/insight360/360-diet-health-icon.png';
import environmentIcon from './images/insight360/360-environment-icon.png';
import foodIcon from './images/insight360/360-food-icon.png';
import healthMedsIcon from './images/insight360/360-health-meds-icon.png';
import internetIcon from './images/insight360/360-internet-icon.png';
import mediaIcon from './images/insight360/360-media-icon.png';
import personalFinanceIcon from './images/insight360/360-personal-finance-icon.png';
import prodPlcmntMoviesIcon from './images/insight360/360-prod-plcmnt-movies-icon.png';
import prodPlcmntTvIcon from './images/insight360/360-prod-plcmnt-tv-icon.png';
import shoppingIcon from './images/insight360/360-shopping-icon.png';
import shoppingBehaviorIcon from './images/insight360/360-shopping-behavior-icon.png';
import socInteractionIcon from './images/insight360/360-soc-interaction-icon.png';
import socialMediaIcon from './images/insight360/360-social-media-icon.png';
import techIcon from './images/insight360/360-tech-icon.png';
import travelIcon from './images/insight360/360-travel-icon.png';
import videoGameIcon from './images/insight360/360-video-game-icon.png';
import healthBeautyIcon from './images/insight360/360-health-beauty-icon.png';
import homeIcon from './images/insight360/360-home-icon.png';
import diningIcon from './images/insight360/360-dining-icon.png';
import cleaningProductsIcon from './images/insight360/360-cleaning-products-icon.png';
import tobaccoIcon from './images/insight360/360-tobacco-icon.png';
import lifestyleIcon from './images/insight360/360-lifestyle-icon.png';
import petsIcon from './images/insight360/360-pets-icon.png';
import printMediaIcon from './images/insight360/360-print-media-icon.png';
import spanishLanguageIcon from './images/insight360/360-spanish-language-icon.png';
import generalIcon from './images/insight360/360-general-icon.png';
// Attitude Mri Icons
import mriBuyingStyleIcon from './images/mri-icons/360-mri-buying-style-icon.png';
import mriFinanceIcon from './images/mri-icons/360-mri-finance-icon.png';
import mriFashionIcon from './images/mri-icons/360-mri-fashion-icon.png';
import mriFoodIcon from './images/mri-icons/360-mri-food-icon.png';
import mriGeneralIcon from './images/mri-icons/360-mri-general-icon.png';
import mriHealthIcon from './images/mri-icons/360-mri-health-icon.png';
import mriInternetIcon from './images/mri-icons/360-mri-internet-icon.png';
import mriTvWatchingIcon from './images/mri-icons/360-mri-tv-watching-icon.png';
import mriTravelIcon from './images/mri-icons/360-mri-travel-icon.png';
import mriAutoIcon from './images/mri-icons/360-mri-auto-icon.png';
import mriTechIcon from './images/mri-icons/360-mri-tech-icon.png';
import mriPoliticalOutlookIcon from './images/mri-icons/360-mri-political-outlook-icon.png';
import mriCustomIcon from './images/mri-icons/360-mri-custom-icon.png';
import customIcon from './images/insight360/360-custom-icon.png';
import yourAttitudesIcon from './images/insight360/attitude.jpg';
import selfConceptsIcon from './images/insight360/selfConcept.jpg';

// mri brands icon..
import mriBabyIcon from './images/mri-icons/360-mri-baby-icon.png';
import mriBeveragesIcon from './images/mri-icons/360-mri-beverages-icon.png';
import mriCandyIcon from './images/mri-icons/360-mri-candy-icon.png';
import mriLeisureSportsIcon from './images/mri-icons/360-mri-leisure-sports-icon.png';
import mriNewspaperIcon from './images/mri-icons/360-mri-newspaper-icon.png';
import mriNonFoodProductsIcon from './images/mri-icons/360-mri-non-food-products-icon.png';
import mriOccupationIcon from './images/mri-icons/360-mri-occupation-icon.png';
import mriPersonalItemIcon from './images/mri-icons/360-mri-personal-item-icon.png';
import mriPetsIcon from './images/mri-icons/360-mri-pets-icon.png';
import mriTobaccoIcon from './images/mri-icons/360-mri-tobacco-icon.png';
import mriRadioIcon from './images/mri-icons/360-mri-tv-watching-icon.png';
import mriHomeIcon from './images/mri-icons/360-mri-home-icon.png';
import mriTelevisionIcon from './images/mri-icons/360-mri-television-icon.png';
import mriAdvertisingAttitudesIcon from './images/insight360/360-mri-advertising-attitudes-icon.jpg';
import mriShoppingIcon from './images/insight360/360-shopping-icon.png';
import mriCellMobileIcon from './images/insight360/360-cellphones-icon.png';
import mriYourAttitudesIcon from './images/insight360/attitude.jpg';
import mriSelfConceptsIcon from './images/insight360/selfConcept.jpg';
import mriSocialMediaIcon from './images/insight360/socialMedia.jpg';

export const SIMMONS_CONNECT_STUDY_STI = 48;
export const SIMMONS_CONNECT_PLUS_STUDY_STI = 56;

/* Insight 360 constants */
export const PERSONA_FILTER_COUNT = 17;
export const PERSONA_SINGLE_COMP_COUNT = 20;
export const PERSONA_DOUBLE_COMP_COUNT = 15;
export const PERSONA_TRIPLE_COMP_COUNT = 12;
export const PROFILE_SINGLE_OUTLOOK_COUNT = 23;
export const PROFILE_SINGLE_TOPS_COUNT = 40;
export const WEIGHTED_LABEL = 'WEIGHTED';
export const REACH_LABEL = 'REACH';
export const SAMPLE_LABEL = 'SAMPLE';
export const INGSIGHT_360_DEMOGRAPHIC_REPORT_NAME = '360DEMOS';
export const INGSIGHT_360_ATTITUDE_REPORT_NAME = '360ATT';
export const INGSIGHT_360_PROFILE_REPORT_NAME = '360PROF';
export const INGSIGHT_360_BRANDS_REPORT_NAME = '360BRANDS';
export const INGSIGHT_360_REPORTVIEW_REPORT_NAME = '360RPTVIEW';
export const INGSIGHT_360_HEADERINFO_REPORT_NAME = '360HEADER';
export const AGREE = 'Agree';
export const ANY_AGREE = 'Any Agree';
export const ANY_DISAGREE = 'Any Disagree';
export const DISAGREE = 'Disagree';
export const NEITHER_AGREE_OR_DISAGREE = 'Neither Agree or Disagree';
export const STRONGLY_AGREE = 'Strongly Agree';
export const STRONGLY_DISAGREE = 'Strongly Disagree';
export const INSIGHT_360_BRANDS_TOP_VALUE = 10;
export const INGSIGHT_360_MEDIA_REPORT_NAME = '360MEDIA';
export const INSIGHT_360_MEDIA_TOP_VALUE = 10;
export const INSIGHT_360_REDUCERS_BASE = 'insight360Base';
export const INSIGHT_360_NOTABLE_TOP_VALUE = 4;
export const BRAND_CATALYST_PREFERENCE_REPORTER_BLOCK_MSG =
  'Data in the bar graph will be restricted to the default metric rules';
export const BRAND_CATALYST_PREFERENCE_REPORTER_AUTO_UPDATE_LABEL =
  'Apply to Reporter Screen:';
export const INSIGHT_360_PROFILE_BRANDS_TOP_VALUE = 5;
export const INSIGHT_360_PROFILE_MEDIA_TOP_VALUE = 5;
export const BRAND_CATALYST_DEFINITION_LENGTH_WARNING =
  'Definition name can be 64 character max';

export const PROFILE_ATTITUDE_GENERAL = 'ATTITUDES (GENERAL) - ANY AGREE';
export const PROFILE_SELF_CONCEPTS = 'SELF-CONCEPTS - ANY AGREE';

export const PROFILE_FINANCIAL_OUTLOOK_FUTURE =
  'DO YOU THINK THAT IN THE COMING 12 MONTHS YOU WILL BE BETTER OFF OR WORSE OFF FINANCIALLY THAN YOU ARE NOW?';
export const PROFILE_FINANCIAL_OUTLOOK_PAST =
  'DO YOU THINK THAT YOU ARE BETTER OFF OR WORSE OFF FINANCIALLY NOW THAN YOU WERE 12 MONTHS AGO?';
export const PROFILE_PURCHASE_BIG_TICKET_ITEM =
  'HOW LIKELY ARE YOU TO PURCHASE A BIG-TICKET ITEM (I.E. MAJOR APPLIANCE, CAR, ETC.) WITHIN THE NEXT 30 DAYS?';
export const PROFILE_PURCHASE_MEDIUM_TICKET_ITEM =
  'HOW LIKELY ARE YOU TO PURCHASE A MEDIUM-TICKET ITEM (I.E. SMALL APPLIANCE, ELECTRONICS, ETC.) WITHIN THE NEXT 30 DAYS?';
export const PROFILE_CONSUMER_CONFIDENCE = 'CONSUMER CONFIDENCE SCALE';
export const PROFILE_PURCHASE_PROPENSITY = 'PURCHASE PROPENSITY SCALE';

export const INSIGHT_360_DICTIONARY_NODE_ID = 0;
export const INSIGHT_360_DEFAULT_DISPLAY_OPTION = 'index';
export const REPORTS_PERSONA_REQUIRED =
  'Please select a persona to view report';
export const REPORTS_DATA_POINT_REQUIRED =
  'Please select a data point from the dictionary panel, to view report';
export const INVALID_PERSONA_SELECTED =
  'Invalid Persona Selected. Numeric study variables are not supported.';
export const INSIGHT_360_PROFILE_LABEL = 'Profile';
export const INSIGHT_360_ATTITUDES_LABEL = 'Attitudes';
export const INSIGHT_360_BRANDS_LABEL = 'Brands';
export const INSIGHT_360_MEDIA_LABEL = 'Media';
export const INSIGHT_360_DEMO_LABEL = 'Demographics';
export const INSIGHT_360_REPORT_LABEL = 'Reports';
export const INSIGHT_360_HEADER_LABEL = 'Header';
export const INSIGHT_360_ERROR_LABEL = 'ERROR';
export const INSIGHT_360_NETWORK_ERROR_DESC =
  'Report failed to load, please try again.';
export const INSIGHT_360_GENERAL_ERROR = 'Invalid Persona Selected.';
export const INSIGHT_360_LESS_BASE_WARNING =
  'Sample size < 60 can result into more NA.';
export const INSIGHT_360_SAMPLE_SIZE_WARNING =
  'Invalid Persona, must have sample size > 0 to explore.';
export const INSIGHT_360_CREATOR_SEGMENT_SIZE_INFO =
  'Size of segment in regard to overall persona.';
export const INSIGHT_360_CREATOR_VARIANCE_INFO =
  'The percentage representation of how greatly the segments differ from one another.';
export const REPORTS_GRAPH_LIMIT_NOTE = 'Selection exceeds maximum limit of';

export const SALES_ATTITUDE_REPORT_NAME = 'SC_ATT';
export const SALES_DEMO_REPORT_NAME = 'SC_DEMOS';
export const SALES_ATTITUDE_REPORT_TOP_VALUE = 10;
export const LENGHT_OF_TARGET_MARKET_HEADER_LABEL = 50;
export const LENGHT_OF_CAROUSEL_HEADER_LABEL = 100;
export const SALES_CATALYST_HEADERINFO_REPORT_NAME = 'SC_HEADER';
export const SALES_CATALYST_SAMPLE_WEIGHTED_REACH_REPORT_NAME =
  'SC_SAMPLE_WGTD_REACH';

export const TARGET_MARKET_HEADING =
  'Select Target Market and Entity to view Overlap Profile';
export const SALES_LESS_BASE_WARNING = 'Sample = 0, cannot run analysis';
export const STRENGTHS = 'strengths';
export const WEAKNESSESS = 'weaknessess';
export const INSIGHT_360_PROFILE_MEDIA_BRAND_TOP_VALUE = 5;

export const DEEP_DIVE_REPORT_NAME = [
  { Demographics: 'DEMOS' },
  { Attitudes: 'ATT' },
  { Brands: 'BRANDS' },
  { Media: 'MEDIA' },
];

export const DEMOGRAPHICS_ICON_LIST = [
  { id: 'demoAgeIcon', demoName: 'Age', selectedIcon: demoAgeIcon },
  {
    id: 'demoChildrenIcon',
    demoName: 'Children in Household',
    selectedIcon: demoChildrenIcon,
  },
  {
    id: 'demoEducationIcon',
    demoName: 'Education',
    selectedIcon: demoEducationIcon,
  },
  {
    id: 'demoEmploymentIcon',
    demoName: 'Employment Status',
    selectedIcon: demoEmploymentIcon,
  },
  {
    id: 'demoEthnicityIcon',
    demoName: 'Ethnicity',
    selectedIcon: demoEthnicityIcon,
  },
  { id: 'demoGenderIcon', demoName: 'Gender', selectedIcon: demoGenderIcon },
  {
    id: 'demoIncomeIcon',
    demoName: 'Household Income',
    selectedIcon: demoIncomeIcon,
  },
  {
    id: 'demoMaritalStatusIcon',
    demoName: 'Marital Status',
    selectedIcon: demoMaritalStatusIcon,
  },
  {
    id: 'demoPoliticalIcon',
    demoName: 'Political Outlook',
    selectedIcon: demoPoliticalIcon,
  },
  { id: 'demoRaceIcon', demoName: 'Race', selectedIcon: demoRaceIcon },
  {
    id: 'demoRegionIcon',
    demoName: 'Census Region',
    selectedIcon: demoRegionIcon,
  },
  {
    id: 'demoResidenceIcon',
    demoName: 'Residence',
    selectedIcon: demoResidenceIcon,
  },
  {
    id: 'demoOccupationIcon',
    demoName: 'Occupation',
    selectedIcon: demoOccupationIcon,
  },
];

export const ATTITUDE_ICON_LIST = [
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360ConsumerPrivacyIcon', selectedIcon: consumerPrivacyIcon },
  { id: '360DietHealthIcon', selectedIcon: dietHealthIcon },
  { id: '360EnvironmentIcon', selectedIcon: environmentIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthMedsIcon },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360MediaIcon', selectedIcon: mediaIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: prodPlcmntMoviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: prodPlcmntTvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360ShoppingBehaviorIcon', selectedIcon: shoppingBehaviorIcon },
  { id: '360SocInteractionIcon', selectedIcon: socInteractionIcon },
  { id: '360SocialMediaIcon', selectedIcon: socialMediaIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360VideoGameIcon', selectedIcon: videoGameIcon },
  { id: '360VideoGameIcon', selectedIcon: videoGameIcon },
  { id: '360GeneralIcon', selectedIcon: generalIcon },
  { id: '360MriFoodIcon', selectedIcon: mriFoodIcon },
  { id: '360MriBuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360MriFinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360MriFashionIcon', selectedIcon: mriFashionIcon },
  { id: '360MriGeneralIcon', selectedIcon: mriGeneralIcon },
  { id: '360MriHealthIcon', selectedIcon: mriHealthIcon },
  { id: '360MriInternetIcon', selectedIcon: mriInternetIcon },
  { id: '360MriTvWatchingIcon', selectedIcon: mriTvWatchingIcon },
  { id: '360MriTravelIcon', selectedIcon: mriTravelIcon },
  { id: '360MriAutoIcon', selectedIcon: mriAutoIcon },
  { id: '360MriTechIcon', selectedIcon: mriTechIcon },
  { id: '360MriPoliticalOutlookIcon', selectedIcon: mriPoliticalOutlookIcon },
  { id: '360MriSimCustomIcon', selectedIcon: mriCustomIcon },
  { id: '360CustomIcon', selectedIcon: customIcon },
  { id: '360MriCellMobileIcon', selectedIcon: mriCellMobileIcon },
  {
    id: '360MriAdvertisingAttitudesIcon',
    selectedIcon: mriAdvertisingAttitudesIcon,
  },
  { id: '360MriShoppingIcon', selectedIcon: mriShoppingIcon },
  { id: '360MriYourAttitudesIcon', selectedIcon: mriYourAttitudesIcon },
  { id: '360MriSelfConceptsIcon', selectedIcon: mriSelfConceptsIcon },
  { id: '360MriSocialMediaIcon', selectedIcon: mriSocialMediaIcon },
  { id: '360YourAttitudesIcon', selectedIcon: yourAttitudesIcon },
  { id: '360SelfConceptsIcon', selectedIcon: selfConceptsIcon },
];

export const BRAND_ICON_LIST = [
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360ConsumerPrivacyIcon', selectedIcon: consumerPrivacyIcon },
  { id: '360DietHealthIcon', selectedIcon: dietHealthIcon },
  { id: '360EnvironmentIcon', selectedIcon: environmentIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthMedsIcon },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360MediaIcon', selectedIcon: mediaIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: prodPlcmntMoviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: prodPlcmntTvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360ShoppingBehaviorIcon', selectedIcon: shoppingBehaviorIcon },
  { id: '360SocInteractionIcon', selectedIcon: socInteractionIcon },
  { id: '360SocialMediaIcon', selectedIcon: socialMediaIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360VideoGameIcon', selectedIcon: videoGameIcon },
  { id: '360HealthBeautyIcon', selectedIcon: healthBeautyIcon },
  { id: '360HomeIcon', selectedIcon: homeIcon },
  { id: '360DiningIcon', selectedIcon: diningIcon },
  { id: '360CleaningProductsIcon', selectedIcon: cleaningProductsIcon },
  { id: '360TobaccoIcon', selectedIcon: tobaccoIcon },
  { id: '360LifestyleIcon', selectedIcon: lifestyleIcon },
  { id: '360PetsIcon', selectedIcon: petsIcon },
  // mri icons..
  { id: '360BabyIcon', selectedIcon: mriBabyIcon },
  { id: '360BeveragesIcon', selectedIcon: mriBeveragesIcon },
  { id: '360CandyIcon', selectedIcon: mriCandyIcon },
  { id: '360LeisureSportsIcon', selectedIcon: mriLeisureSportsIcon },
  { id: '360NewspaperIcon', selectedIcon: mriNewspaperIcon },
  { id: '360NonFoodProductsIcon', selectedIcon: mriNonFoodProductsIcon },
  { id: '360OccupationIcon', selectedIcon: mriOccupationIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360HhPetsIcon', selectedIcon: mriPetsIcon },
  { id: '360TobaccoProductsIcon', selectedIcon: mriTobaccoIcon },
  { id: '360TvWatchingIcon', selectedIcon: mriRadioIcon },
  { id: '360BuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360FinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360HomeImprovementIcon', selectedIcon: mriHomeIcon },
  { id: '360TelevisionIcon', selectedIcon: mriTelevisionIcon },
  { id: '360TravelPlanningIcon', selectedIcon: mriTravelIcon },
];

export const MEDIA_ICON_LIST = [
  { id: '360ApparelIcon', selectedIcon: apparelIcon },
  { id: '360AutoIcon', selectedIcon: autoIcon },
  { id: '360CellphonesIcon', selectedIcon: cellphonesIcon },
  { id: '360FoodIcon', selectedIcon: foodIcon },
  { id: '360InternetIcon', selectedIcon: internetIcon },
  { id: '360ProdPlcmntMoviesIcon', selectedIcon: prodPlcmntMoviesIcon },
  { id: '360ProdPlcmntTvIcon', selectedIcon: prodPlcmntTvIcon },
  { id: '360ShoppingIcon', selectedIcon: shoppingIcon },
  { id: '360TechIcon', selectedIcon: techIcon },
  { id: '360TravelIcon', selectedIcon: travelIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360HealthMedsIcon', selectedIcon: healthMedsIcon },
  { id: '360PersonalFinanceIcon', selectedIcon: personalFinanceIcon },
  { id: '360CleaningProductsIcon', selectedIcon: cleaningProductsIcon },
  { id: '360DiningIcon', selectedIcon: diningIcon },
  { id: '360TobaccoIcon', selectedIcon: tobaccoIcon },
  { id: '360HealthBeautyIcon', selectedIcon: healthBeautyIcon },
  { id: '360HomeIcon', selectedIcon: homeIcon },
  { id: '360LifestyleIcon', selectedIcon: lifestyleIcon },
  { id: '360PetsIcon', selectedIcon: petsIcon },
  { id: '360PrintMediaIcon', selectedIcon: printMediaIcon },
  { id: '360SpanishLanguageIcon', selectedIcon: spanishLanguageIcon },
  // Mri icons..
  { id: '360BabyIcon', selectedIcon: mriBabyIcon },
  { id: '360BeveragesIcon', selectedIcon: mriBeveragesIcon },
  { id: '360CandyIcon', selectedIcon: mriCandyIcon },
  { id: '360LeisureSportsIcon', selectedIcon: mriLeisureSportsIcon },
  { id: '360NewspaperIcon', selectedIcon: mriNewspaperIcon },
  { id: '360NonFoodProductsIcon', selectedIcon: mriNonFoodProductsIcon },
  { id: '360OccupationIcon', selectedIcon: mriOccupationIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360PersonalItemIcon', selectedIcon: mriPersonalItemIcon },
  { id: '360HhPetsIcon', selectedIcon: mriPetsIcon },
  { id: '360TobaccoProductsIcon', selectedIcon: mriTobaccoIcon },
  { id: '360TvWatchingIcon', selectedIcon: mriRadioIcon },
  { id: '360BuyingStyleIcon', selectedIcon: mriBuyingStyleIcon },
  { id: '360FinanceIcon', selectedIcon: mriFinanceIcon },
  { id: '360HomeImprovementIcon', selectedIcon: mriHomeIcon },
  { id: '360TelevisionIcon', selectedIcon: mriTelevisionIcon },
  { id: '360TravelPlanningIcon', selectedIcon: mriTravelIcon },
];

export const COLOR_CODES_FOR_CATEGORIES = [
  { Default: 'rgb(190, 190, 190)' },
  { Apparel: 'rgb(218, 199, 221)' },
  { Automobiles: 'rgb(244, 205, 191)' },
  { 'Cell phones/smartphones': 'rgb(202, 220, 240)' },
  { 'Consumer Privacy': 'rgb(238, 176, 136)' },
  { 'Diet and Health': 'rgb( 228, 238, 208)' },
  { Environment: 'rgb( 214, 232, 208)' },
  { Food: 'rgb( 200, 227, 207)' },
  { 'Health & Medicine': 'rgb( 193, 228, 229)' },
  { 'Health and Medicine': 'rgb( 193, 228, 229)' },
  { Internet: 'rgb( 194, 211, 233)' },
  { Media: 'rgb( 194, 201, 226)' },
  { 'Personal Finance': 'rgb( 250, 227, 200)' },
  { 'Product Placement Movies': 'rgb( 247, 212, 222)' },
  { 'Product Placement TV': 'rgb( 244, 206, 206)' },
  { Shopping: 'rgb( 227, 212, 231)' },
  { 'Shopping Behavior': 'rgb( 235, 181, 222)' },
  { 'Social Interactions': 'rgb( 133, 205, 242)' },
  { 'Social Media': 'rgb( 134, 131, 185)' },
  { Technology: 'rgb(250, 235, 187)' },
  { Travel: 'rgb( 249, 247, 176)' },
  { 'Print Media': 'rgb( 194, 201, 226)' },
  { 'Video Games': 'rgb( 157, 136, 186)' },
  { Television: 'rgb( 244, 206, 206)' },
  { Lifestyle: 'rgb(228, 238, 208)' },
  { Dining: 'rgb(246, 215, 195)' },
  { Pets: 'rgb( 214, 232, 208)' },
  { Movies: 'rgb( 247, 212, 222)' },
  { 'Health & Beauty': 'rgb( 245, 218, 238)' },
  { 'Health and Beauty': 'rgb( 245, 218, 238)' },
  { 'PP Movies': 'rgb( 239, 170, 189)' },
  { 'PP TV': 'rgb( 233, 157, 158)' },
  { 'Cleaning Products': 'rgb(206, 195, 220)' },
  { Home: 'rgb(194, 230, 248)' },
  { Tobacco: 'rgb(194, 193, 220)' },
];

export const DEFAULT_REACH = 10;
export const DEFAULT_SAMPLE = 60;
export const DEFAULT_INDEX = { selectedOption: 'Highest', value: [0] };

// mri studies color code
export const COLOR_CODES_FOR_MRI_CATEGORIES = [
  { Apparel: 'rgb(218, 199, 221)' },
  { Automobiles: 'rgb(244, 205, 191)' },
  { 'Cell phones/smartphones': 'rgb(202, 220, 240)' },
  { 'Consumer Privacy': 'rgb(238, 176, 136)' },
  { 'Diet and Health': 'rgb( 228, 238, 208)' },
  { Environment: 'rgb( 214, 232, 208)' },
  { Food: 'rgb( 200, 227, 207)' },
  { 'Health & Medicine': 'rgb( 193, 228, 229)' },
  { 'Health and Medicine': 'rgb( 193, 228, 229)' },
  { Internet: 'rgb( 194, 211, 233)' },
  { Media: 'rgb( 194, 201, 226)' },
  { 'Personal Finance': 'rgb( 250, 227, 200)' },
  { 'Product Placement Movies': 'rgb( 247, 212, 222)' },
  { 'Product Placement TV': 'rgb( 244, 206, 206)' },
  { Shopping: 'rgb( 227, 212, 231)' },
  { 'Shopping Behavior': 'rgb( 235, 181, 222)' },
  { 'Social Interactions': 'rgb( 133, 205, 242)' },
  { 'Social Media': 'rgb( 134, 131, 185)' },
  { Technology: 'rgb(250, 235, 187)' },
  { 'Travel Planning': 'rgb( 133, 205, 242)' },
  { 'Print Media': 'rgb( 194, 201, 226)' },
  { 'Video Games': 'rgb( 157, 136, 186)' },
  // { Television: 'rgb(244, 205, 191)' },
  { Lifestyle: 'rgb(228, 238, 208)' },
  { Dining: 'rgb(246, 215, 195)' },
  { Pets: 'rgb( 214, 232, 208)' },
  { Movies: 'rgb( 247, 212, 222)' },
  { 'Health & Beauty': 'rgb( 245, 218, 238)' },
  { 'Health and Beauty': 'rgb( 245, 218, 238)' },
  { 'PP Movies': 'rgb( 239, 170, 189)' },
  // { 'PP TV': 'rgb( 233, 157, 158)' },
  { TV: 'rgb( 244, 206, 206)' },
  { 'Cleaning Products': 'rgb(206, 195, 220)' },
  { 'Home Improvement': 'rgb(194, 230, 248)' },
  { 'Tobacco Products': 'rgb(194, 193, 220)' },
  { Default: 'rgb(190, 190, 190)' },
  { 'Fashion & Style': 'rgb(218, 199, 221)' },
  { Finance: 'rgb( 250, 227, 200)' },
  { Health: 'rgb( 193, 228, 229)' },
  { Automotive: 'rgb(244, 205, 191)' },
  // { General: '' },
  { 'Internet/Online': 'rgb( 194, 211, 233)' },
  { 'TV Watching': 'rgb( 244, 206, 206)' },
  { 'Buying Style': 'rgb( 227, 212, 231)' },
  { Food: 'rgb( 200, 227, 207)' },
  { Technology: 'rgb(250, 235, 187)' },
  { 'Vacation Travel': 'rgb( 133, 205, 242)' },
  // mri brand..
  { 'HH Non-Food': 'rgb(244, 205, 191)' },
  { 'HH Pets': 'rgb( 249, 247, 176)' },
  { Candy: 'rgb(227, 212, 231)' },
  { 'Leisure/Sports': 'rgb( 194, 211, 233)' },
  { Newspaper: 'rgb( 194, 211, 233)' },
  { Beverages: 'rgb( 228, 238, 208)' },
  { 'Personal Item': 'rgb( 194, 211, 233)' },
  { 'Baby/Children': 'rgb(244, 205, 191)' },
];
// module feature ids
export const CROSSTAB_FEATUREID = 1;
export const QUICKREPORTS_FEATUREID = 2;
export const DATAHAUL_FEATUREID = 3;
export const STORIES_FEATUREID = 4;
export const BRAND_CATALYST_FEATUREID = 5;
export const SALES_CATALYST_FEATUREID = 6;
export const TURNKEY_OMNIBUS_FEATUREID = 7;
export const MME_FEATUREID = 8;
export const GEOMAPPING_FEATUREID = 9;
export const CORRCLUSTER_FEATUREID = 10; // added by JedK (need a real data)
export const CAMP_TGTS_FEATUREID = 11; // added Campaign Targets module
export const ENABLEMENT_MODULE_ID = 4; // added enablement module
export const AUTOCODE_ACCESS_ID = -1; // added by krushi (PLAT-9167)

export const REPORT_COLORS = ['#fc946f', '#abcd75', '#57caef'];
export const INSIGHT360_EXPLORE = 'EXPLORE';
export const INSIGHT360_REPORTS = 'REPORTS';
export const INSIGHT360_PERSONA_CREATOR = 'CREATOR';
export const LENGHTOF_PDF_LABEL = 200;
export const LENGTH_OF_SEGMENT_LABEL = 100;
export const REPORT_GRAPH_ITEM_LIMIT = 50;

export const INSIGHT360_PERSONA_CREATOR_SEGMENTCOUNT = [3, 4, 5, 6, 7, 8, 9];
export const SAMPLE_SIZE_RESTRICTION = 60;
export const SEGMENT_FILTER_LENGTH = 80;

export const PERSONA_CREATOR_DEF_LENGTH = 64;
export const MAX_SEGMENT_LABEL_TEXT_COUNT = 1024;
export const UPDATE_FOR_SEGMENT_LABEL = 'UPDATE_FOR_SEGMENT_LABEL';
export const UPDATE_FOR_DEFINITION_LABEL = 'UPDATE_FOR_DEFINITION_LABEL';
export const SELECTED_FILTER_LABEL = 'Selected Filter';

export const VERTICAL_PERCENT_FILTER_VALUE = 10;
export const INSIGHT_360_PERCENTAGE_FILTER_INFO =
  'Filter the results on the screen based on reach, default is 10%.';

export const INSIGHT_360_LABEL = 'Brand Catalyst';
export const INSIGHTS_360_URL = 'brandCatalyst';
export const QTS_BRAND_NAME = 'Turn-Key Omnibus';
export const INSIGHT_QTS_DICTIONARY_PRODUCT_NO = 6179;
export const INSIGHT_QTS_DICTIONARY_NODE_ID = 0;
export const SEGMENT_SIZE_LABEL = 'Segment Size';

export const QTS_FALL_2018_CUTOFF = new Date('2018-11-15');

export const VISA_HAUL_LABEL = 'Stories';
export const MME_LABEL = 'MME';

// Sales Catalyst
export const SALES_CATALYST = 'Sales Catalyst';
export const SALES_CATALYST_DEFAULT_SELECTED_TAB = 'TARGET MARKET';
export const SALES_CATALYST_TARGET_TAB = 'TARGET';
export const SALES_CATALYST_MDEDIA_TAB = 'PACKAGE';
export const SALES_CATALYST_INPUTS = 'INPUTS';
export const SALES_CATALYST_AUDIENCE_OVERLAP = 'AUDIENCE OVERLAP';
export const SALES_CATALYST_COMPETITION = 'COMPETITION';
export const SALES_CATALYST_COMPETITION_LABEL = 'COMPARE';
export const SALES_CATALYST_PROFILE_DEEP_DIVE = 'PROFILE DEEP DIVE';
export const SALES_CATALYST_MEDIA_PACKAGE = 'MEDIA PACKAGE';
export const SALES_CATALYST_TARGET_MARKET = 'TARGET MARKET';
export const SALES_CATALYST_BRAND_AUDIENCE = 'Brand Audience';
export const SALES_CATALYST_BRAND_SUB_AUDIENCE = 'Brand Sub-Audience';
export const SALES_CATALYST_BRAND_COMPETITORS = 'Brand Competitors';
export const SALES_CATALYST_BRAND_MARKET = 'Brand Market';
export const SALES_CATALYST_PITCH_AUDIENCE = 'Pitch Audience';
export const SALES_CATALYST_PITCH_SUB_AUDIENCE = 'Pitch Sub-Audience';
export const SALES_CATALYST_PITCH_COMPETITORS = 'Pitch Competitors';
export const SALES_CATALYST_PITCH_MARKET = 'Pitch Market';
export const SALES_CATALYST_MAX_AUDIENCE = 1;
export const SALES_CATALYST_MAX_SUB_AUDIENCE = 3;
export const SALES_CATALYST_MAX_COMPETITORS = 3;
export const SALES_CATALYST_MAX_MARKET = 1;
export const SALES_CATALYST_MAX_SUBENTITIES = 15;
export const SALES_CATALYST_MAX_TARGETMARKET = 1;
export const SALES_CATALYST_MAX_ENTITY = 1;
export const SALES_CATALYST_MAX_BRAND = 1;
export const SALES_CATALYST_BRAND_SELECTION = 'brandSelection';
export const SALES_CATALYST_PITCH_SELECTION = 'pitchSelection';
export const SALES_CATALYST_DATA_SELECTION = 'dataSelection';
export const SALES_CATALYST_DATA_TARGET_MARKET = 'Target Market';
export const SALES_CATALYST_DATA_ENTITY = 'Entity';
export const SALES_CATALYST_DATA_SUBENTITIES = 'SubEntities';
export const SALES_CATALYST_DATA_COMPETITOR = 'Competitor';
export const SALES_CATALYST_DATA_CATEGORY = 'Category';
export const SALES_CATALYST_DATA_BRAND = 'Brand';
export const SALES_CATALYST_REDUCERS_AUDIENCE = 'audience';
export const SALES_CATALYST_REDUCERS_SUB_AUDIENCE = 'subAudience';
export const SALES_CATALYST_REDUCERS_COMPETITORS = 'competitors';
export const SALES_CATALYST_REDUCERS_MARKET = 'market';
export const SALES_CATALYST_REDUCERS_BASE = 'salesCatalystBase';
export const SAVE_SALES_CATALYST_TEMPLATE_LENGTH = 128;
export const DEFINITION_HEADER_LENGTH = 64;
export const SC_TARGET_ENTITY_REPORT = 'SC_TARGET_ENTITY';
export const SC_TARGET_ENTITY_BRAND_REPORT = 'SC_TARGET_ENTITY_BRAND';
export const SC_TARGET_REPORT = 'SC_TARGET';
export const SC_TARGET_BRAND_REPORT = 'SC_TARGET_BRAND';
export const SC_SUB_ENTITY_REPORT = 'SC_SUB_ENTITY';
export const SALES_CATALYST_API_AUDIENCE = 'audience';
export const SALES_CATALYST_API_SUBENTITIES = 'subentities';
export const SC_BRAND_REPORT = 'SC_BRANDS';
export const SC_MEDIA_REPORT = 'SC_MEDIA';
export const SALES_CATALYST_RESET_ALL = 'SALES_CATALYST_RESET_ALL';
export const SIMMONS_DATA = 'sd';
export const ALL = 'all';
export const SC_CHART_CONFIG = {
  marginTop: 15,
  marginBottom: 10,
  pointWidth: 20,
  barPadding: 5,
  maxItems: 15,
  colors: ['#b8e6e6', '#d2e9ce'],
};
export const SC_SELECTED_SUBENTITY_LIST = 'selectedList';
export const SC_APPLIED_SUBENTITY_LIST = 'appliedList';
export const SC_IS_SUBENTITY_LIST_UPDATED = 'isListModified';
export const SC_PACKAGE_CHARTS = 'SC_PACKAGE_CHARTS';
export const SC_PACKAGE = 'SC_PACKAGE';
export const SC_MEDIA_PREFERENCES = 'SC_MEDIA_PREFERENCES';
export const SC_COMPETITORS = 'SC_COMPETITORS';
export const SC_ACTIVITIES = 'SC_ACTIVITIES';
export const SC_SPORTS_INTERESTS = 'SC_SPORTS_INTERESTS';
export const SC_BASE = 'Universe/Base';
export const SC_TARGET_MARKET = 'Target';
export const SC_BASE_MARKET_SELECTOR_VAL = 'baseMarketSelectorVal';
export const SC_COMPETITORS_ACTIVITIES = 'SC_COMPETITORS_ACTIVITIES';
export const SC_COMPETITORS_COMPARISON = 'SC_COMPETITORS_COMPARISON';
export const SC_COMPETITORS_COMPARISON_SEL_OPTIONS = {
  selectedOptions: [
    'strengthsListDefault',
    'weaknessesListDefault',
    'activitiesListDefaults',
  ],
};

export const COLOR_CODES_FOR_SALESCATALYST = [
  { TARGETMARKET: 'rgb(132,201,204)' },
  { ENTITY: 'rgb(233,155,127)' },
  { ENTITYTARGETOVERLAP: 'black' },
  { BRAND: 'rgb(173,213,166)' },
  { CATEGORY: 'rgb(173,213,166)' },
  { SUBENTITY: 'rgb(244,205,191)' },
  { SUBENTITYOVERLAP: 'rgb(193,228,229)' },
  { BRANDOVERLAP: 'rgb(244,205,191)' },
  { COMPETITORS1: 'rgb(173,213,166)' },
  { COMPETITORS2: 'rgb(235,181,222)' },
  { COMPETITORS3: 'rgb(248,218,123)' },
];
export const COMPETITION_DEFAULT_TEXT_COLOR = 'rgb(190,190,190)';
export const COMPETITION_TEXT_COLOR = 'rgb(50,50,50)';
export const COMPETITION_AFTER_RUN_TEXT_COLOR = 'white';
export const COMPETITION_DEFAULT_BACKGROUND_COLOR = 'rgb(240,240,240)';
export const DISPLAY_SUB_ENTITY_CHART_COUNT = 4;
export const DISPLAY_BRAND_CHART_COUNT = 4;

export const MEDIA_PACKAGE_CHART_LIST = [0, 1, 2, 3];
export const SC_COMPARE_CHART_COLORS = [
  {
    fillColor: 'rgba(244,150,125,0.8)',
    lineColor: 'rgb(233,155,127)',
  },
  {
    fillColor: 'rgba(174,212,168,0.8)',
    lineColor: 'rgb(173,213,166)',
  },
  {
    fillColor: 'rgba(150,185,226,0.8)',
    lineColor: 'rgb(235,181,222)',
  },
  {
    fillColor: 'rgba(247,217,129,0.8)',
    lineColor: 'rgb(248,218,123)',
  },
];

// usage tracker constants
export const TOOL_OPEN_CROSSTAB = 'TOOL_OPEN_CROSSTAB';
export const TOOL_IMPORT_SPC = 'TOOL_IMPORT_SPC';
export const TOOL_SAVE_CROSSTAB = 'TOOL_SAVE_CROSSTAB';
export const TOOL_SHARE_BUTTON = 'TOOL_SHARE_BUTTON';
export const TOOL_EXPORT_XLS = 'TOOL_EXPORT_XLS';
export const TOOL_EXPORT_SPC = 'TOOL_EXPORT_SPC';
export const TOOL_EXPORT_CSV = 'TOOL_EXPORT_CSV';
export const TOOL_CHART_PRIVATE_EYE = 'TOOL_CHART_PRIVATE_EYE';
export const TOOL_CHART_CROSSTAB = 'TOOL_CHART_CROSSTAB';
export const TOOL_CHART_QUAD = 'TOOL_CHART_QUAD';
export const TOOL_CHART_TREND = 'TOOL_CHART_TREND';
export const TOOL_VIEW_HIGHLIGHT = 'TOOL_VIEW_HIGHLIGHT';
export const TOOL_VIEW_SAMPLE = 'TOOL_VIEW_SAMPLE';
export const TOOL_VIEW_WEIGHTED = 'TOOL_VIEW_WEIGHTED';
export const TOOL_VIEW_VERTICAL = 'TOOL_VIEW_VERTICAL';
export const TOOL_VIEW_HORIZONTAL = 'TOOL_VIEW_HORIZONTAL';
export const TOOL_VIEW_INDEX = 'TOOL_VIEW_INDEX';
export const TOOL_VIEW_CLEAR_ALL = 'TOOL_VIEW_CLEAR_ALL';
export const TOOL_GRID_BASE_EDIT = 'TOOL_GRID_BASE_EDIT';
export const TOOL_GRID_COLUMN_EDIT = 'TOOL_GRID_COLUMN_EDIT';
export const TOOL_GRID_ROW_EDIT = 'TOOL_GRID_ROW_EDIT';
export const DICTIONARY_SEARCH_CLICK = 'DICTIONARY_SEARCH_CLICK';
export const SMART_SEARCH_CLICK = 'SMART_SEARCH_CLICK';
export const ADD_CROSSTAB_GRID_COLUMN = 'ADD_CROSSTAB_GRID_COLUMN';
export const ADD_CROSSTAB_GRID_ROW = 'ADD_CROSSTAB_GRID_ROW';
export const ADD_CROSSTAB_GRID_BASE = 'ADD_CROSSTAB_GRID_BASE';
export const ADD_DICTIONARY_DATA_GRID_ROW = 'ADD_DICTIONARY_DATA_GRID_ROW';
export const ADD_DICTIONARY_DATA_GRID_COLUMN =
  'ADD_DICTIONARY_DATA_GRID_COLUMN';
export const ADD_DICTIONARY_DATA_GRID_BASE = 'ADD_DICTIONARY_DATA_GRID_BASE';
export const PAGE_VISIT_QUICKREPORTS = 'PAGE_VISIT_QUICKREPORTS';
export const PAGE_VISIT_CROSSTAB = 'PAGE_VISIT_CROSSTAB';
export const PAGE_VISIT_BRAND_CATALYST = 'PAGE_VISIT_BRAND_CATALYST';
export const PAGE_VISIT_SALES_CATALYST = 'PAGE_VISIT_SALES_CATALYST';
export const PAGE_VISIT_DATAHAUL = 'PAGE_VISIT_DATAHAUL';
export const PAGE_VISIT_TURNKEY_OMBINUS = 'PAGE_VISIT_TURNKEY_OMBINUS';
export const PAGE_VISIT_STORIES = 'PAGE_VISIT_STORIES';
export const DATAHAUL_RUN_REPORT = 'DATAHAUL_RUN_REPORT';
export const STORIES_RUN_REPORT = 'STORIES_RUN_REPORT';
export const QUICKREPORT_RUN_REPORT = 'QUICKREPORT_RUN_REPORT';
export const ADD_MME_GRID_BASE = 'ADD_MME_GRID_BASE';
export const ADD_MME_GRID_TARGET = 'ADD_MME_GRIDTARGET';
export const TOOL_OPEN_MME = 'TOOL_OPEN_MME';
// export const BRANDCATALYST_RUN_REPORT = 'BRANDCATALYST_RUN_REPORT';
export const BRANDCATALYST_EXPORT_REPORT = 'BRANDCATALYST_EXPORT_REPORT';
export const QUICKREPORT_EXPORT_REPORT = 'QUICKREPORT_EXPORT_REPORT';
export const ADD_DICTIONARY_BOX_COLUMN = 'ADD_DICTIONARY_BOX_COLUMN';
export const ADD_DICTIONARY_BOX_ROW = 'ADD_DICTIONARY_BOX_ROW';
export const ADD_DICTIONARY_BOX_BASE = 'ADD_DICTIONARY_BOX_BASE';
export const ADD_SMARTSEARCH_GRID_ROW = 'ADD_SMARTSEARCH_GRID_ROW';
export const ADD_SMARTSEARCH_GRID_COLUMN = 'ADD_SMARTSEARCH_GRID_COLUMN';
export const ADD_SMARTSEARCH_GRID_BASE = 'ADD_SMARTSEARCH_GRID_BASE';
export const MOVE_TO_BASE_FROM_SCRATCH = 'MOVE_TO_BASE_FROM_SCRATCH';
export const MOVE_TO_COLUMN_FROM_SCRATCH = 'MOVE_TO_COLUMN_FROM_SCRATCH';
export const MOVE_TO_ROW_FROM_SCRATCH = 'MOVE_TO_ROW_FROM_SCRATCH';
export const COPY_TO_BASE_FROM_SCRATCH = 'COPY_TO_BASE_FROM_SCRATCH';
export const COPY_TO_COLUMN_FROM_SCRATCH = 'COPY_TO_COLUMN_FROM_SCRATCH';
export const COPY_TO_ROW_FROM_SCRATCH = 'COPY_TO_ROW_FROM_SCRATCH';
export const MOVE_TO_ROW_FROM_QUESTION = 'MOVE_TO_ROW_FROM_QUESTION';
export const MOVE_TO_COLUMN_FROM_QUESTION = 'MOVE_TO_COLUMN_FROM_QUESTION';
export const MOVE_TO_BASE_FROM_QUESTION = 'MOVE_TO_BASE_FROM_QUESTION';
export const MOVE_TO_BASE_FROM_CRB = 'MOVE_TO_BASE_FROM_CRB';
export const MOVE_TO_COLUMN_FROM_CRB = 'MOVE_TO_COLUMN_FROM_CRB';
export const MOVE_TO_ROW_FROM_CRB = 'MOVE_TO_ROW_FROM_CRB';
export const COPY_TO_BASE_FROM_CRB = 'COPY_TO_BASE_FROM_CRB';
export const COPY_TO_COLUMN_FROM_CRB = 'COPY_TO_COLUMN_FROM_CRB';
export const COPY_TO_ROW_FROM_CRB = 'COPY_TO_ROW_FROM_CRB';
export const TOOL_TARGET_CLEAR_ALL = 'TOOL_TARGET_CLEAR_ALL';
export const TOOL_TARGET_EDIT_CLICK = 'TOOL_TARGET_EDIT_CLICK';
export const TOOL_BASE_CLEAR_ALL = 'TOOL_BASE_CLEAR_ALL';
export const TOOL_COLUMN_CLEAR_ALL = 'TOOL_COLUMN_CLEAR_ALL';
export const DATAHAUL_EXPORT_REPORT = 'DATAHAUL_EXPORT_REPORT';
export const MODULE_DEMOGRAPHIC_PROFILE = 'DEMOGRAPHIC_PROFILE';
export const MODULE_SEGMENTATION = 'SEGMENTATION';
export const MODULE_SIMULTANEOUS_USAGE = 'SIMULTANEOUS_USAGE';
export const MODULE_SOCIAL_MEDIA_ACTIVITY = 'SOCIAL_MEDIA_ACTIVITY';
export const MODULE_MEDIA_ACTIVITY_PLATFORM = 'MEDIA_ACTIVITY_PLATFORM';
export const MODULE_TIME_SPENT = 'TIME_SPENT';
export const MODULE_MEDIA_PLATFORM_ACTIVITY = 'MEDIA_PLATFORM_ACTIVITY';
export const MODULE_REACH_QUICKREPORTS = 'REACH_QUICKREPORTS';
export const MODULE_DIGITAL_ACTIVITY_PROFILE = 'DIGITAL_ACTIVITY_PROFILE';
// constants for segments in Segmentation and DAP report
export const MOBILE_WORLD = 'Mobile World';
export const MOBILITY_ADOPTION = 'Mobility Adoption';
export const MOBILE_SEGMENT_COMPOSITION = 'Mobile Segment Composition';
export const MODULE_DAY_IN_LIFE = 'DAY_IN_LIFE';
export const MODULE_CHANNEL_CATEGORY = 'CHANNEL_CATEGORY';
export const MODULE_INCREMENTAL_REACH = 'INCREMENTAL_REACH';
export const MODULE_WEBSITE_VISITATION = 'MODULE_WEBSITE_VISITATION';
export const USE_QUESTION_TEXT_SELECT = 'USE_QUESTION_TEXT_SELECT';
export const USE_QUESTION_TEXT_DESELECT = 'USE_QUESTION_TEXT_DESELECT';
export const CODING_BOX_VERIFY_CLICK = 'CODING_BOX_VERIFY_CLICK';
export const CODING_BOX_DEFINE_CLICK = 'CODING_BOX_DEFINE_CLICK';
export const CODING_BOX_CLEAR_CLICK = 'CODING_BOX_CLEAR_CLICK';
export const CODING_BOX_SAVE_CLICK = 'CODING_BOX_SAVE_CLICK';
export const CODING_BOX_AUTO_FORMAT_SELECT = 'CODING_BOX_AUTO_FORMAT_SELECT';
export const CODING_BOX_AUTO_FORMAT_DESELECT =
  'CODING_BOX_AUTO_FORMAT_DESELECT';
export const CODING_BOX_OR_OPERATOR_CLICK = 'CODING_BOX_OR_OPERATOR_CLICK';
export const CODING_BOX_AND_OPERATOR_CLICK = 'CODING_BOX_AND_OPERATOR_CLICK';
export const CODING_BOX_NOT_OPERATOR_CLICK = 'CODING_BOX_NOT_OPERATOR_CLICK';
export const CODING_BOX_XOR_OPERATOR_CLICK = 'CODING_BOX_XOR_OPERATOR_CLICK';
export const CODING_BOX_OPEN_PARANTHESIS_CLICK =
  'CODING_BOX_OPEN_PARANTHESIS_CLICK';
export const CODING_BOX_CLOSING_PARANTHESIS_CLICK =
  'CODING_BOX_CLOSING_PARANTHESIS_CLICK';
export const CODING_BOX_ADVANCED_BUTTON_CLICK =
  'CODING_BOX_ADVANCED_BUTTON_CLICK';
export const SELECT_ALL_ITEMS_FROM_SCRATCH = 'SELECT_ALL_ITEMS_FROM_SCRATCH';
export const DELETE_SCRATCH_FROM_SCRATCH = 'DELETE_SCRATCH_FROM_SCRATCH';
export const ADD_TO_DEFINITION_FROM_SCRATCH = 'ADD_TO_DEFINITION_FROM_SCRATCH';
export const FUNCTIONS_MENU_FROM_SCRATCH = 'FUNCTIONS_MENU_FROM_SCRATCH';
export const SCRATCH_TAB_SELECTED = 'SCRATCH_TAB_SELECTED';
export const DROP_DATAPOINT_TO_SCRATCH = 'DROP_DATAPOINT_TO_SCRATCH';
export const ADD_DATAPOINT_TO_SCRATCH = 'ADD_DATAPOINT_TO_SCRATCH';
export const CREATOR_SAVE_TEMPLATE_NAME = 'CREATOR_SAVE_TEMPLATE_NAME';
export const EXPLORE_BUTTON_CLICK = 'EXPLORE_BUTTON_CLICK';
export const ADD_BUTTON_CLICK = 'ADD_BUTTON_CLICK';
export const REMOVE_PERSONA_CLICK = 'REMOVE_PERSONA_CLICK';
export const RESET_BUTTON_CLICK = 'RESET_BUTTON_CLICK';
export const SET_BASE_BUTTON_CLICK = 'SET_BASE_BUTTON_CLICK';
export const CHANGE_FILTER_FROM_HEADER = 'CHANGE_FILTER_FROM_HEADER';
export const CHANGE_FILTER_FROM_BRANDS = 'CHANGE_FILTER_FROM_BRANDS';
export const CHANGE_FILTER_FROM_MEDIA = 'CHANGE_FILTER_FROM_MEDIA';
export const SELECT_QUESTION_FOR_REPORT = 'SELECT_QUESTION_FOR_REPORT';
export const CHANGE_SORT_OPTION_REPORTER = 'CHANGE_SORT_OPTION_REPORTER';
export const SELECT_PERCENT_FILTER_REPORTER = 'SELECT_PERCENT_FILTER_REPORTER';
export const SELECT_INDEX_FILETR_REPORTER = 'SELECT_INDEX_FILETR_REPORTER';
export const REACH_PERCENTAGE_CHANGED_EXPLORER =
  'REACH_PERCENTAGE_CHANGED_EXPLORER';
export const REACH_PERCENTAGE_CHANGED_CREATOR =
  'REACH_PERCENTAGE_CHANGED_CREATOR';
export const APPLY_SEGMENT_CLUSTERS_CREATOR = 'APPLY_SEGMENT_CLUSTERS_CREATOR';
export const INVALID_PERSONA_EXPRESSION_SELECTED =
  'INVALID_PERSONA_EXPRESSION_SELECTED';
export const INVALID_BASE_EXPRESSION_SELECTED =
  'INVALID_BASE_EXPRESSION_SELECTED';
export const SAVE_CREATOR_DEFINITION_LABEL = 'SAVE_CREATOR_DEFINITION_LABEL';
export const CREATE_BUTTON_CLICK = 'CREATE_BUTTON_CLICK';
export const SAVE_LAST_CROSSTAB_BTN_CLICK = 'SAVE_LAST_CROSSTAB_BTN_CLICK';
export const DISCARD_LAST_CROSSTAB_BTN_CLICK =
  'DISCARD_LAST_CROSSTAB_BTN_CLICK';
export const OPEN_LAST_CROSSTAB_BTN_CLICK = 'OPEN_LAST_CROSSTAB_BTN_CLICK';
export const CLOSE_MODAL_BTN_CLICK = 'CLOSE_MODAL_BTN_CLICK';
export const CROSSTAB_RUN_REPORT_SS = 'CROSSTAB_RUN_REPORT_SS';
export const CROSSTAB_RUN_REPORT_DS = 'CROSSTAB_RUN_REPORT_DS';

export const ACTION_TYPE_SCRATCH = 'ACTION_TYPE_SCRATCH';
export const ACTION_TYPE_CRGBGRIDMENU = 'ACTION_TYPE_CRGBGRIDMENU';
export const ACTION_TYPE_QUESTION = 'ACTION_TYPE_QUESTION';
export const ACTION_TYPE_CUSTOM_DROPDOWN = 'ACTION_TYPE_CUSTOM_DROPDOWN';
export const ACTION_TYPE_CRGB_GRIDS = 'ACTION_TYPE_CRGB_GRIDS';
export const ACTION_TYPE_TOOL_GRID = 'ACTION_TYPE_TOOL_GRID';
export const ACTION_TYPE_OLD_SMART_SEARCH_CLICKED =
  'ACTION_TYPE_OLD_SMART_SEARCH_CLICKED';
export const ACTION_TYPE_NEW_SMART_SEARCH_CLICKED =
  'ACTION_TYPE_NEW_SMART_SEARCH_CLICKED';

export const SIMMONS_EXTERNAL_DEFAULT_KEY = 'simmonsinsights';

export const STUDY_UNIVERSE_LABEL = 'STUDY UNIVERSE';
export const COPMPARISON_TABLE_EXPAND_GRAPH_LENGTH = 15;
export const COPMPARISON_TABLE_GRAPH_LENGTH = 5;

export const PREFERENCE_BASE_EXPORT_LIST = [
  'User-Defined Only',
  'Standard Only',
  'User-Defined & Standard',
  'Current Selection',
];
export const PREFERENCE_POPUP_LABEL =
  'Are you sure you want to continue? Your preferences will not be saved or applied if you click OK';

export const DATAHAUL_CONSTANT = 'DataHaul';
export const VISAHAUL_CONSTANT = 'VisaHaul';

export const CROSSTAB_CONSTANT = 'crosstab';
export const QUICKREPORTS_CONSTANT = 'quickReports';
export const QTS_CONSTANT = 'qts';
export const CLUSTER_CORRESPONDENCE_MODULE = 'ClusterCorrespondence';

export const DV_DEFAULT_VALUE = 1000;
/* SalesCatalyst Preference */

export const PREFERENCE_SALES_CATALYST = '_sc';
export const PREFERENCE_BRAND_CATALYST = '_bc';
export const PREFERENCE_STUDY = '_ds';
export const PREFERENCE_SALES_CATALYST_TARGETMARKET = '_tm';
export const PREFERENCE_SALES_CATALYST_ENTITY = '_ep';
export const PREFERENCE_SALES_CATALYST_BASE = '_bp';
export const PREFERENCE_SALES_CATALYST_COMPETITOR = '_cdp';
export const PREFERENCE_SALES_CATALYST_REACH = '_rfs';
export const PREFERENCE_SALES_CATALYST_SAMPLE = '_smfs';
export const PREFERENCE_SALES_CATALYST_INDEX = '_irf';
export const PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST = '_stl';
export const PREFERENCE_SALES_CATALYST_SAVE_SE_LIST = '_svl';
export const PREFERENCE_SALES_CATALYST_SUBENTITIES = '_se';
export const PREFERENCE_SMART_SEARCH = '_ss';
export const PREFERENCE_SALES_CATALYST_STRENGTH_REACH = '_srfs';
export const PREFERENCE_SALES_CATALYST_STRENGTH_INDEX = '_sirf';
export const PREFERENCE_SALES_CATALYST_STRENGTH_SAMPLE_MINIMUM = '_ssmfs';
export const PREFERENCE_SALES_CATALYST_WEAKNESSES_REACH = '_wrfs';
export const PREFERENCE_SALES_CATALYST_WEAKNESS_INDEX = '_wirf';
export const PREFERENCE_SALES_CATALYST_WEAKNESS_SAMPLE_MINIMUM = '_wsmfs';
export const PREFERENCE_SALES_CATALYST_MEDIA_FILTER_LIST = '_ml';
export const PREFERENCE_SALES_CATALYST_BRAND_FILTER_LIST = '_bl';
export const PREFERENCE_SALES_CATALYST_SCATTERPLOT_CATEGORY = '_sdc';
export const PREFERENCE_SALES_CATALYST_SCATTERPLOT_BASE = '_sdb';
export const PREFERENCE_SALES_CATALYST_STUDY_FAMILY = '_sf';
export const PREFERENCE_BRAND_CATALYST_REACH = '_rfs';
export const PREFERENCE_BRAND_CATALYST_SAMPLE = '_smfs';
export const PREFERENCE_BRAND_CATALYST_INDEX = '_irf';
export const PREFERENCE_BRAND_CATALYST_AUTO_UPDATE = '_aus';
export const PREFERENCE_BRAND_CATALYST_MEDIA_FILTER_LIST = '_ml';
export const PREFERENCE_BRAND_CATALYST_BRAND_FILTER_LIST = '_bl';
export const PREFERENCE_BRAND_CATALYST_STUDY_FAMILY = '_sf';
export const PREFERENCE_BRAND_PROFILE_ATTITUDE_STATEMENT = '_bas';

export const SALES_CATALYST_PREFERENCE_KEY_MAPPING = [
  // { LABEL: PREFERENCE_SALES_CATALYST_TARGETMARKET, CATEGORY: 'targetMarket', MAINCATEGORY: 'dataSelection' },
  // { LABEL: PREFERENCE_SALES_CATALYST_ENTITY, CATEGORY: 'entity', MAINCATEGORY: 'dataSelection' },
  {
    LABEL: PREFERENCE_SALES_CATALYST_BASE,
    CATEGORY: 'salesCatalystBase',
    MAINCATEGORY: '',
  },
  //  { LABEL: PREFERENCE_SALES_CATALYST_COMPETITOR, CATEGORY: 'competitor', MAINCATEGORY: 'dataSelection' },
  //  { LABEL: PREFERENCE_SALES_CATALYST_SELECTED_SE_LIST, CATEGORY: SC_APPLIED_SUBENTITY_LIST, MAINCATEGORY: ['scConfiguration', 'package'] },
  {
    LABEL: PREFERENCE_SALES_CATALYST_MEDIA_FILTER_LIST,
    CATEGORY: 'media',
    MAINCATEGORY: ['scTarget', 'selectedFilters'],
  },
  {
    LABEL: PREFERENCE_SALES_CATALYST_BRAND_FILTER_LIST,
    CATEGORY: 'brands',
    MAINCATEGORY: ['scTarget', 'selectedFilters'],
  },
  {
    LABEL: PREFERENCE_SALES_CATALYST_SCATTERPLOT_CATEGORY,
    CATEGORY: 'scatterplotDefaultCategory',
    MAINCATEGORY: 'scCompetition',
  },
  {
    LABEL: PREFERENCE_SALES_CATALYST_SCATTERPLOT_BASE,
    CATEGORY: SC_BASE_MARKET_SELECTOR_VAL,
    MAINCATEGORY: 'scCompetition',
  },
];

export const RANGE_FILTER_DEFAULT = {
  'Greater Than': [120],
  'Less Than': [90],
  Equals: [130],
  Range: [110, 120],
  Highest: [0],
};
// SalesCatalyst_Prefrence

export const TARGET_MARKET_COLOR = '_tmc';
export const ENTITY_COLOR = '_ec';
export const COMPETITOR1_COLOR = '_cc1';
export const COMPETITOR2_COLOR = '_cc2';
export const COMPETITOR3_COLOR = '_cc3';

export const SALES_CATALYST_COLOR_CODE = [
  {
    label: 'TARGETMARKET',
    key: TARGET_MARKET_COLOR,
    color: 'rgb(132,201,204)',
  },
  { label: 'ENTITY', key: ENTITY_COLOR, color: 'rgb(233,155,127)' },
  { label: 'COMPETITORS1', key: COMPETITOR1_COLOR, color: 'rgb(173,213,166)' },
  { label: 'COMPETITORS2', key: COMPETITOR2_COLOR, color: 'rgb(235,181,222)' },
  { label: 'COMPETITORS3', key: COMPETITOR3_COLOR, color: 'rgb(248,218,123)' },
];
// crosstab preferences
export const PREFERENCE_CROSSTAB = '_ct';
export const PREFERENCE_CHART_VIEW = '_cv';
export const PREFERENCE_STUDY_WEIGHTING = '_sw';
export const PREFERENCE_CROSSTAB_EDITOR = '_dv';
export const PREFERENCE_STUDY_SELECTOR_POPUP = '_ssp';
export const PREFERENCE_BASE_EXPORT = '_be';
export const PREFERENCE_STUDY_UNIVERSE = '_su';
export const PREFERENCE_METRICS = '_el';

// quick reports preferences
export const PREFERENCE_QUICKREPORTS = '_qr';

// DataHaul Preferences
export const PREFERENCE_DATAHAUL = '_dh';

// Stories Preferences
export const PREFERENCE_STORIES = '_st';

// Confidential
export const MRI_TAG_NAME = '© MRI-Simmons';
export const COPY_RIGHT_TEXT = 'Proprietary and Confidential.';

// SMARTSEARCH
export const SMARTSEARCH_NORESULTS_FOUND =
  'No Results Found. Please refine your search.';
export const STRENGTHS_FILTER_CONFIG = 'strengthFilterConfig';
export const WEAKNESS_FILTER_CONFIG = 'weaknessFilterConfig';
export const PAGE_VISIT_PREFERENCE = 'PAGE_VISIT_PREFERENCE';
export const PAGE_VISIT_SESSION = 'PAGE_VISIT_SESSION';
export const SMART_SEARCH_SALES_CATALYST_PAGE =
  'SMART_SEARCH_SALES_CATALYST_PAGE';

// Brand Catalyst Preferences
export const PREFERENCE_BRAND_CATALYST_BASE = '_bp';

export const BRAND_CATALYST_PREFERENCE_KEY_MAPPING = [
  {
    LABEL: PREFERENCE_BRAND_PROFILE_ATTITUDE_STATEMENT,
    MAINCATEGORY: '',
    CATEGORY: 'excludesProfileAttList',
  },
  {
    LABEL: PREFERENCE_BRAND_CATALYST_BASE,
    CATEGORY: 'insight360Base',
    MAINCATEGORY: '',
  },
  {
    LABEL: PREFERENCE_BRAND_CATALYST_MEDIA_FILTER_LIST,
    CATEGORY: 'media',
    MAINCATEGORY: 'selectedFilters',
  },
  {
    LABEL: PREFERENCE_BRAND_CATALYST_BRAND_FILTER_LIST,
    CATEGORY: 'brands',
    MAINCATEGORY: 'selectedFilters',
  },
];
// Flex studies
export const FLEX_STUDY_TAG = 'slcl';

// Indexes
export const SIMMONS_V3 = 'simmons_v3';
export const SIMMONS_V2 = 'simmons_v2';
export const MRI_INDEX_V3 = 'mri_index_v3';

// MRI studies
export const MRI_STUDY_NAME_FLAG = 'MRI';
export const MRI_PROFILE_ATTITUDE_GENERAL = 'ATTITUDES (GENERAL)';
export const MRI_PROFILE_PAST_FINANCIAL_OUTLOOK = 'PAST FINANCIAL OUTLOOK';
export const MRI_PROFILE_FUTURE_FINANCIAL_OUTLOOK = 'FUTURE FINANCIAL OUTLOOK';
export const MRI_PAST_ECONOMIC_OUTLOOK_COUNTRY =
  'PAST ECONOMIC OUTLOOK OF COUNTRY';
export const MRI_FUTURE_ECONOMIC_OUTLOOK_COUNTRY =
  'FUTURE ECONOMIC OUTLOOK OF COUNTRY';
export const MRI_PUBLIC_ACTIVITIES = 'PUBLIC ACTIVITIES IN LAST 12 MONTHS';
export const NIELSEN_V3_INDEX = 'simmons_v3_nielsen';
export const CONNECT_NEW_INDEX = 'simmons_v4_connect';
export const CONNECT_V2_OLD = 'simmons_v2_connectors';
export const CONNECT_V3_OLD = 'simmons_v3_connect';
export const LOCAL_V3_INDEX = 'simmons_v3_local';

// MRI Study Warnings.
export const MRI_STUDY_WARNING_TYPE_6 = 6;
export const MRI_STUDY_WARNING_TYPE_7 = 7;
export const MRI_STUDY_WARNING_TYPE_8 = 8;

// Support left Navigation
export const SUPPORT_LEFT_NAV_ITEMS = [
  {
    name: 'Resources',
    title: 'Resources',
    active: false,
    activeChild: 'User Guides',
    children: ['User Guides', 'Study Resources'],
  },
  {
    name: 'Releases',
    title: 'Release Schedules',
    active: false,
    activeChild: '',
    children: [],
  },
  {
    name: 'Notifications',
    title: 'Notifications',
    active: false,
    activeChild: 'Insights',
    children: ['Insights', 'Studies'],
  },
  {
    name: 'Contact Us',
    title: 'Contact Us',
    active: false,
    activeChild: '',
    children: [],
  },
];
export const TP_SUPPORT_LEFT_NAV_ITEMS = [
  {
    name: 'Resources',
    title: 'Resources',
    active: false,
    activeChild: 'Study Resources',
    children: ['Study Resources'],
  },
  {
    name: 'Notifications',
    title: 'Notifications',
    active: false,
    activeChild: 'Insights',
    children: ['Insights', 'Studies'],
  },
  {
    name: 'Contact Us',
    title: 'Contact Us',
    active: false,
    activeChild: '',
    children: [],
  },
];

// section sort keys..
export const SET_SECTION_SORT_KEY = 'SET_SECTION_SORT_KEY';
export const SECTION_SORT_BY_PROFILE = 'profiles';
export const SECTION_SORT_BY_MEDIA = 'media';
export const SECTION_SORT_BY_BRANDS = 'brands';
export const SECTION_SORT_BY_ATTITUDES = 'attitudes';
export const SECTION_SORT_BY_DEMOS = 'demographics';

// Profile media and brand section..
export const PROFILE_BRAND_LIST = 'profileBrandList';
export const PROFILE_MEDIA_LIST = 'profileMediaList';
export const CROSSTAB_SAVE_PLACEHOLDER_LABEL = 'Enter Crosstab Name';
export const CROSSTAB_SAVE_WARNING_TEXT = 'Please enter crosstab name to save';

export const GEO_MAP_MODULE_NAME = 'GeoMap';

export const EXPORT_NAME_CONSTANT = 'MRI-Simmons';

// Breadcrumbs display Grid features constants
export const MIN_ROW_HEIGHT = 35;
export const MIN_COLUMN_HEIGHT = 45;

export const MIN_ROW_TEXT_HEIGHT = 15.6;
export const MIN_COLUMN_TEXT_HEIGHT = 15.4;

export const MAX_ROW_TEXT_NUM = 34;
export const MAX_COLUMN_TEXT_NUM = 69;
export const MIN_COLUMN_TEXT_NUM = 46;

export const GRID_ROW_COL_MAX_TEXT = 500;

// Crosstab View Grid constants
export const CROSSTAB_COLUMN_MIN_HEIGHT = 75;
export const CROSSTAB_COLUMN_TEXT_HEIGHT = 17.8;
export const CROSSTAB_MIN_ROW_HEIGHT = 140;

// Probabilities NA constant
export const CROSSTAB_PROBABILITIES_NA_CONSTANT = '@ N/A';
export const CROSSTAB_PROBABILITIES_MESSAGE =
  'Publications with probability-based readership values are crossed or combined with themselves. Please click on edit to manually code these.';

// Probabilities Functions
export const PROBABILTIES_FUNCTIONS = [
  {
    label: 'Average Issue',
    value: 'avg',
  },
  {
    label: 'Six month readers',
    value: 'audscreen',
  },
  {
    label: 'In home readers',
    value: 'audinhome',
  },
  {
    label: 'Out-of-home readers',
    value: 'audoutofhome',
  },
  {
    label: 'Primary readers',
    value: 'audprimary',
  },
  {
    label: 'Secondary readers',
    value: 'audsecondary',
  },
  {
    label: 'Buyers',
    value: 'audbuyers',
  },
  {
    label: 'Read in a doctor’s office',
    value: 'auddoctor',
  },
  {
    label: 'Read in a barbershop or beauty salon',
    value: 'audbarber',
  },
  {
    label: 'Read in a library',
    value: 'audlibrary',
  },
  {
    label: 'Read in an office reception area',
    value: 'audreception',
  },
  {
    label: 'Read during commute',
    value: 'audcommute',
  },
  {
    label: 'Read on a plane',
    value: 'audplane',
  },
  {
    label: 'Read while other travelling',
    value: 'audtravel',
  },
  {
    label: 'Read at work',
    value: 'audatwork',
  },
  {
    label: 'Read in a store or newsstand',
    value: 'audstore',
  },
  {
    label: 'Read in another home',
    value: 'audotherhome',
  },
  {
    label: 'Read in own home',
    value: 'audownhome',
  },
  {
    label: 'Read elsewhere',
    value: 'audelsewhere',
  },
  {
    label: 'Took any action after reading',
    value: 'audanyact',
  },
  {
    label: 'Rating: One of my favorites',
    value: 'audrtfav',
  },
  {
    label: 'Rating: Very good',
    value: 'audrtvery',
  },
  {
    label: 'Rating: Good',
    value: 'audrtgood',
  },
  {
    label: 'Rating: Fair',
    value: 'audrtfair',
  },
  {
    label: 'Rating: Poor',
    value: 'audrtpoor',
  },
  {
    label: 'Visited magazine website',
    value: 'audwebsite',
  },
  {
    label: 'Noted an ad',
    value: 'audadnoted',
  },
  {
    label: 'Print+Digital audience',
    value: 'auddigpr',
  },
  {
    label: 'Print+Digital six month readers',
    value: 'audpdscreen',
  },
  {
    label: 'Average Issue Audience',
    value: 'aud',
  },
];
// contract admin left Navigation
export const CONTRACT_ADMIN_LEFT_NAV_ITEMS = [
  {
    name: 'Contract',
    title: 'Contract',
    active: false,
    activeChild: 'Search',
    children: ['Search', 'Details', 'Entitlement Creation', 'Summary'],
  },
  {
    name: 'Contact Directory',
    title: 'Contact Directory',
    active: false,
    activeChild: '',
    children: [],
  },
];
// Contract Admin header..
export const CA_CONTRACT_NAME = 'Contract Name';
export const CA_CONTRACT_ACCOUNT = 'Account Name';
export const CA_LAST_MODIFIED = 'Last Modified';
export const CA_PARENT_ACCOUNT = 'Parent Account';

export const CA_TYPE = 'Type';
export const CA_STATUS = 'Status';
export const CA_CONTRACT_START = 'Contract Start';
export const CA_CONTRACT_END = 'Contract End';
export const CONTRACT_ADMIN_SEARCH_DROPDOWN_OPTIONS = [
  { value: 'account', label: 'Account' },
  { value: 'contract', label: 'Contract' },
  { value: 'parentAccount', label: 'Parent Acct' },
];
export const CA_ADD_CONTRACT_STATUS_OPTIONS = [
  { value: 'A', label: 'Active' },
  { value: 'H', label: 'On Hold' },
  { value: 'D', label: 'Disabled' },
];
export const CA_ADD_CONTRACT_COUNTRY_OPTIONS = [
  { value: 'USA', label: 'USA' },
  { value: 'OTHER', label: 'OTHER' },
];
export const CA_ADD_CONTRACT_ACCESS_OPTIONS = [
  { value: 'NATIONALSTUDY', label: 'Access based on National Study' },
  { value: 'CONTRACT', label: 'Access based on Contract Term' },
];
export const CA_UNIVERSITY_SELECTION_OPTIONS = [
  { value: 'TWOYRBACKDATA', label: '(2) Two Year back data' },
  { value: 'NOBACKDATA', label: 'Current data-no back data' },
];
export const CA_ADD_CONTRACT_STATE_OPTIONS = [
  { value: 'Alabama - AL', label: 'Alabama - AL', sortcode: 'AL' },
  { value: 'Alaska - AK', label: 'Alaska - AK', sortcode: 'AK' },
  { value: 'Arizona - AZ', label: 'Arizona - AZ', sortcode: 'AZ' },
  { value: 'Arkansas - AR', label: 'Arkansas - AR', sortcode: 'AR' },
  { value: 'California - CA', label: 'California - CA', sortcode: 'CA' },
  { value: 'Colorado - CO', label: 'Colorado - CO', sortcode: 'CO' },
  { value: 'Connecticut - CT', label: 'Connecticut - CT', sortcode: 'CT' },
  {
    value: 'District of Columbia - DC',
    label: 'District of Columbia - DC',
    sortcode: 'DC',
  },
  { value: 'Delaware - DE', label: 'Delaware - DE', sortcode: 'DE' },
  { value: 'Florida - FL', label: 'Florida - FL', sortcode: 'FL' },
  { value: 'Georgia - GA', label: 'Georgia - GA', sortcode: 'GA' },
  { value: 'Hawaii - HI', label: 'Hawaii - HI', sortcode: 'HI' },
  { value: 'Idaho - ID', label: 'Idaho - ID', sortcode: 'ID' },
  { value: 'Illinois - IL', label: 'Illinois - IL', sortcode: 'IL' },
  { value: 'Indiana - IN', label: 'Indiana - IN', sortcode: 'IN' },
  { value: 'Iowa - IA', label: 'Iowa - IA', sortcode: 'IA' },
  { value: 'Kansas - KS', label: 'Kansas - KS', sortcode: 'KS' },
  { value: 'Kentucky - KY', label: 'Kentucky - KY', sortcode: 'KY' },
  { value: 'Louisiana - LA', label: 'Louisiana - LA', sortcode: 'LA' },
  { value: 'Maine - ME', label: 'Maine - ME', sortcode: 'ME' },
  { value: 'Maryland - MD', label: 'Maryland - MD', sortcode: 'MD' },
  { value: 'Massachusetts - MA', label: 'Massachusetts - MA', sortcode: 'MA' },
  { value: 'Michigan - MI', label: 'Michigan - MI', sortcode: 'MI' },
  { value: 'Minnesota - MN', label: 'Minnesota - MN', sortcode: 'MN' },
  { value: 'Mississippi - MS', label: 'Mississippi - MS', sortcode: 'MS' },
  { value: 'Missouri - MO', label: 'Missouri - MO', sortcode: 'MO' },
  { value: 'Montana - MT', label: 'Montana - MT', sortcode: 'MT' },
  { value: 'Nebraska - NE', label: 'Nebraska - NE', sortcode: 'NE' },
  { value: 'Nevada - NV', label: 'Nevada - NV', sortcode: 'NV' },
  { value: 'New Hampshire - NH', label: 'New Hampshire - NH', sortcode: 'NH' },
  { value: 'New Jersey - NJ', label: 'New Jersey - NJ', sortcode: 'NJ' },
  { value: 'New Mexico - NM', label: 'New Mexico - NM', sortcode: 'NM' },
  { value: 'New York - NY', label: 'New York - NY', sortcode: 'NY' },
  {
    value: 'North Carolina - NC',
    label: 'North Carolina - NC',
    sortcode: 'NC',
  },
  { value: 'North Dakota - ND', label: 'North Dakota - ND', sortcode: 'ND' },
  { value: 'Ohio - OH', label: 'Ohio - OH', sortcode: 'OH' },
  { value: 'Oklahoma - OK', label: 'Oklahoma - OK', sortcode: 'OK' },
  { value: 'Oregon - OR', label: 'Oregon - OR', sortcode: 'OR' },
  { value: 'Pennsylvania - PA', label: 'Pennsylvania - PA', sortcode: 'PA' },
  { value: 'Rhode Island - RI', label: 'Rhode Island - RI', sortcode: 'RI' },
  {
    value: 'South Carolina - SC',
    label: 'South Carolina - SC',
    sortcode: 'SC',
  },
  { value: 'South Dakota - SD', label: 'South Dakota - SD', sortcode: 'SD' },
  { value: 'Tennessee - TN', label: 'Tennessee - TN', sortcode: 'TN' },
  { value: 'Texas - TX', label: 'Texas - TX', sortcode: 'TX' },
  { value: 'Utah - UT', label: 'Utah - UT', sortcode: 'UT' },
  { value: 'Vermont - VT', label: 'Vermont - VT', sortcode: 'VT' },
  { value: 'Virginia - VA', label: 'Virginia - VA', sortcode: 'VA' },

  { value: 'Washington - WA', label: 'Washington - WA', sortcode: 'WA' },
  { value: 'West Virginia - WV', label: 'West Virginia - WV', sortcode: 'WV' },
  { value: 'Wisconsin - WI', label: 'Wisconsin - WI', sortcode: 'WI' },
  { value: 'Wyoming - WY', label: 'Wyoming - WY', sortcode: 'WY' },
];
// share crosstab
export const SHARE_CROSSTAB_ACCESS_ID = -2;

export const UPDATE_STUDY_STORAGE_KEY = 'supportStudy';
export const UPDATE_STUDY_LIST_STORAGE_KEY = 'updatedStudyList';
export const SUPPORT_MENU_NAME = 'Support';

export const CA_CREATE_ACCOUNT_VERTICAL_OPTIONS = [
  { value: 'Agency', label: 'Agency' },
  { value: 'Brand', label: 'Brand' },
  { value: 'Media', label: 'Media' },
  { value: 'Partner', label: 'Partner' },
  { value: 'Print', label: 'Print' },
  { value: 'University', label: 'University' },
];
export const CA_CREATE_ACCOUNT_ACCESS_OPTIONS = [
  { value: 'STANDARD', label: 'Standard' },
  { value: 'TPP', label: 'Third Party' },
  { value: 'UNIVERSITY', label: 'University' },
];

// tracking events for autocode feature
export const PAGE_VISIT_AUTOCODE = 'PAGE_VISIT_AUTOCODE';
export const AUTOCODE_RUN_BTN_CLICK = 'AUTOCODE_RUN_BTN_CLICK';
export const AUTOCODE_SETUP_BULK_JOIN = 'AUTOCODE_SETUP_BULK_JOIN';
export const AUTOCODE_CANCEL_BULK_JOIN = 'AUTOCODE_CANCEL_BULK_JOIN';
export const AUTOCODE_FUNCTION_BTN_CLICK = 'AUTOCODE_FUNCTION_BTN_CLICK';
export const AUTOCODE_FUNCTION_COUNT_EXACTLY_RADIO_CLICK =
  'AUTOCODE_FUNCTION_COUNT_EXACTLY_RADIO_CLICK';
export const AUTOCODE_FUNCTION_COUNT_MINMAX_RADIO_CLICK =
  'AUTOCODE_FUNCTION_COUNT_MINMAX_RADIO_CLICK';
export const AUTOCODE_BACK_TO_CROSSTAB_BTN_CLICK =
  'AUTOCODE_BACK_TO_CROSSTAB_BTN_CLICK';
export const AUTOCODE_STUDY_CHANGE_EVENT = 'AUTOCODE_STUDY_CHANGE_EVENT';

// Concurrent user model error message
export const ERROR_MESSAGES = [
  {
    key: 'MAX_CONCURRENT_USER_LIMIT_EXCEED',
    value:
      'The maximum number of concurrent users has been met, please reach out internally.',
  },
];

export const SIGNOUT_MESSAGE = 'Sign Out and return to login page.';
export const CA_MODULE_TITLE = 'Contract Administration';
export const CA_ROUTER_LEAVE_LABEL =
  'Are you sure you want to continue? Your changes will not be saved if you click OK';

export const CA_NAV_DISABLING_MSG =
  'Please select an existing entry or add a new one.';

export const VIMEO_IDS = [
  { key: 'crosstab', value: '524961616' },
  { key: 'quickreports', value: '524962118' },
  { key: 'datahaul', value: '524961777' },
  { key: 'geomap', value: '524961870' },
  { key: 'brandcatalyst', value: '524961152' },
  { key: 'mme', value: '524961926' },
];

export const RLD_TOOL = 'RldTool';

export const IP_REGEX = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;

export const ERROR_ADDANOTHER_IP =
  'Please fill in required IP addresses before adding another.';
export const ERROR_RANGE_FIELDS_IP =
  'Please enter both IP addresses in the range.';
export const ERROR_INVALID_IP = 'You have entered an invalid IP address!';
export const CA_ADD_CONTRACT_DEFAULT_STATUS_OPTIONS = {
  value: 'A',
  label: 'Status',
};
export const CA_MODAL_STATIC_TEXT =
  'The status for all selected items will be changed';

export const CA_ACCOUNT_SELECTION = [
  { value: 'No Link', label: 'No Account Link' },
  { value: 'Child Link', label: 'Child Account' },
  { value: 'Parent Link', label: 'Parent Account' },
];
export const CA_ACCOUNT_SELECTION_NO_CHILD = [
  { value: 'No Link', label: 'No Account Link' },
  { value: 'Parent Link', label: 'Parent Account' },
];

export const LANDING_PAGE_URL = '/v2';
export const PROD_HOST = 'insights.mrisimmons.com';
export const BETA_HOST = 'insightsbeta.mrisimmons.com';
export const PROD_CATALYST_URL = 'https://catalyst.mrisimmons.com';
export const BETA_CATALYST_URL = 'https://catalystbeta.mrisimmons.com';
